<template>
  <div>
    <TitleBar>
        <template v-slot:title><translate>Balance Sheet Investments</translate></template>
        <template v-slot:buttons>
            <OnboardingIntroLink :onboarding-intro="'onboarding_web_investments'" />
            <GekkoButton 
                @click="goToFinancialReporting()" 
                :text="$gettext('Financial Statements')" 
                icon="fa-solid fa-arrow-up-right-from-square"
                :icon-right="true"
                variant="link"
                class="mr-2"
            />
            <GekkoButton 
                @click="addInvestmentItem()" 
                :text="$gettext('New investment')" 
                icon="fa-solid fa-plus"
                class="m-2"
            />
            <b-dropdown class="icon-toggle ui-dashboard-menu-dropdown" variant="outline-primary" right no-caret>
                <template #button-content>
                    <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
                </template>
                <b-dropdown-item @click="addCostCategory()">
                    <font-awesome-icon icon="fa-solid fa-cart-shopping" />
                    <span v-translate>Add cost type</span>
                </b-dropdown-item>
                <b-dropdown-item @click="download()">
                    <font-awesome-icon icon="fa-solid fa-download" />
                    <span v-translate>Download</span>
                </b-dropdown-item>
            </b-dropdown>
        </template>
    </TitleBar>
    <div class="content balancesheet">
        <BalanceSheetTable ref="balancesheettable" />
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import BalanceSheetTable from '@/components/balance_sheet/BalanceSheetTable.vue';
import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

export default {
    name: 'BalanceSheet',
    components: { GekkoButton, TitleBar, BalanceSheetTable, OnboardingIntroLink },
    data () {
        return {
        }
    },
    created() {
        window.onbeforeunload = this.onWindowClose;
        
    },
    mounted() {
        this.$router.beforeEach((to, from, next) => {
            let navigate = true;
            if (from.name === "BalanceSheet") {
                if (to.name !== "CostTypes" && to.name !== "BalanceSheetEditCost" && to.name !== "AddItem" && to.name !== "EditItem") {
                    
                    if (this.$refs.balancesheettable) {
                        if (this.$refs.balancesheettable.editedRowId) {
                            if (!confirm(this.$gettext(`Changes you made may not be saved. Do you still want to navigate to ` + to.name + '?')))
                                navigate = false;
                        }
                    }

                }
            }

            if (navigate)
                next();
        });
    },
    destroyed () {
        window.onbeforeunload = null;
    },
    methods: {
        addInvestmentItem() {
            var isPremium = this.$store.getters['getIsPremium'];
            if (isPremium)
                this.$router.push({name: 'AddItem'});
            else
                this.$store.commit('togglePremiumModal', 'web_reporting_investments');
        },
        download() {
            location.href = window.Urls['investments:export_investments']();
        },
        addCostCategory() {
            this.$router.push({name: 'CostTypes'});
        },
        areRowsEdited() {
            return true;
        },
        onWindowClose() {
            if (this.$refs.balancesheettable.editedRowId) {
                return true;
            }
        },
        goToFinancialReporting() {
            this.$router.push({name: 'FinancialStatements'});
        }
    }
}
</script>

<style lang="scss">

</style>